import { v4 as uuid } from 'uuid';
import ROUTES from '../constants/routes';

const NavbarDefault = [
	{
		id: uuid(),
		menuitem: 'Solutions',
		link: '#',
		children: [
			{
				id: uuid(),
				menuitem: 'Sexual Health',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Weight Loss',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Anti-Aging',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Fertility',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Hair',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Skin',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Daily Health',
				link: '/marketing/course-category/'
			},
			{
				id: uuid(),
				menuitem: 'Community',
				link: '/marketing/course-category/'
			}
		]
	},
	{
		id: uuid(),
		menuitem: 'Weight Loss',
		link: '#',
		children: [
			{
				id: uuid(),
				menuitem: 'Compounded Semaglutide',
				link: ROUTES.PRODUCT_DETAILS + '/se'
			},
			{
				id: uuid(),
				menuitem: 'Ozempic® (Semaglutide)',
				link: ROUTES.PRODUCT_DETAILS + '/oz'
			},
			// {
			// 	id: uuid(),
			// 	menuitem: `Compounded Tirzepatide`,
			// 	link: ROUTES.PRODUCT_DETAILS + '/ti'
			// },

			{
				id: uuid(),
				menuitem: `Zepbound® (Tirzepatide)`,
				link: ROUTES.PRODUCT_DETAILS + '/ze'
			}
		]
	},
	{
		id: uuid(),
		menuitem: 'Wellness & Longevity',
		link: '#',
		children: [
			{
				id: uuid(),
				menuitem: `NAD+`,
				link: ROUTES.PRODUCT_DETAILS + '/na'
			},
			{
				id: uuid(),
				menuitem: `Glutathione`,
				link: ROUTES.PRODUCT_DETAILS + '/gl'
			},
			{
				id: uuid(),
				menuitem: 'Metformin',
				link: ROUTES.PRODUCT_DETAILS + '/me'
			},
			{
				id: uuid(),
				menuitem: 'Sermorelin',
				link: ROUTES.PRODUCT_DETAILS + '/ser'
			}
		]
	}
];

export default NavbarDefault;
